export enum ASSET_PATH {
  BACKGROUND_PNG = 'login-background.png',
  HOMEPAGE_HERO_GETTING_STARTED_CARD = 'homepage_hero_card.png',
  HOMEPAGE_HERO_GETTING_STARTED_STORE = 'homepage_hero_store.png',
  HOMEPAGE_HERO_GETTING_STARTED_CLAIMS = 'homepage_hero_claims.png',
  ALEGEUS_RETAIL_HSA_PNG = 'alegeus-retail-hsa.png',
  HSA_BENEFICIARIES_FORM = 'documents/Hsa_Beneficiaries_Form.pdf',
  HSA_CLOSURE_FORM = 'documents/Hsa_Closure_Form.pdf',
}
